import { useState, useEffect } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';
import { Video } from '../types'; // Correção 1: Importar de types
import { videoService, VideoFormData } from '../services/video.service';

interface UseVideoFormProps {
    video: Video | null;
    onClose: () => void;
}

interface UseVideoFormReturn {
    form: UseFormReturn<VideoFormData>;
    levels: string[];
    loadingMeta: boolean;
    thumb: string;
    fetchMetadata: (url: string) => Promise<void>;
    onSubmit: (data: VideoFormData) => Promise<void>;
}

export const useVideoForm = ({ video, onClose }: UseVideoFormProps): UseVideoFormReturn => {
    const form = useForm<VideoFormData>({
        defaultValues: { level: '' }
    });
    const { setValue } = form;

    const [levels, setLevels] = useState<string[]>([]);
    const [loadingMeta, setLoadingMeta] = useState(false);
    const [thumb, setThumb] = useState<string>('');

    useEffect(() => {
        if (video) {
            setValue('title', video.title);
            setValue('description', video.description);
            // Casting opcional se duration vier undefined, mas a interface diz que é string
            setValue('duration', video.duration);
            setValue('url', video.url);
            setValue('level', video.level);
            setValue('icon', video.icon);
            setThumb(video.icon || '');
        }
    }, [video, setValue]);

    useEffect(() => {
        const loadLevels = async () => {
            try {
                const data = await videoService.getLevels();
                setLevels(data || []);
            } catch (error) {
                console.error('Falha ao carregar níveis', error);
                setLevels([]);
            }
        };
        loadLevels();
    }, []);

    const fetchMetadata = async (url: string) => {
        if (!url) return;

        // Basic validation to avoid unnecessary calls
        const isYouTube = /^(https?:\/\/)?((www\.)?youtube\.com\/(watch\?v=|shorts\/)|youtu\.be\/)[\w-]+/i.test(url);
        if (!isYouTube) return;

        setLoadingMeta(true);
        try {
            // Correção 2: Método agora existe no serviço
            const meta = await videoService.fetchYouTubeMetadata(url);
            if (meta) {
                if (meta.title) setValue('title', meta.title.length > 100 ? meta.title.substring(0, 100) + '...' : meta.title);
                if (meta.description) setValue('description', meta.description ? (meta.description.length > 200 ? meta.description.substring(0, 200) + '...' : meta.description) : 'Descripción no disponible');
                if (meta.duration) setValue('duration', meta.duration || 'Duración no disponible');
                if (meta.thumbnailUrl) {
                    setValue('icon', meta.thumbnailUrl);
                    setThumb(meta.thumbnailUrl);
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingMeta(false);
        }
    };

    const onSubmit = async (data: VideoFormData) => {
        try {
            if (video) {
                // Correção 3: updateVideo -> update
                await videoService.update(video.id, data);
            } else {
                // Correção 4: createVideo -> create
                await videoService.create(data);
            }
            onClose();
        } catch (err) {
            console.error('Error al guardar vídeo:', err);
            alert('Error al guardar vídeo');
        }
    };

    return {
        form,
        levels,
        loadingMeta,
        thumb,
        fetchMetadata,
        onSubmit
    };
};